export default {"src":"/_next/static/media/user-circle-solid.23d19829.svg","height":512,"width":512};